import { NgModule } from '@angular/core';
import { ImportantInformationComponent } from "./important-information.component";
import { CommonModule } from "@angular/common";
import { BtnModule } from "libraries/ui_button/btn.module";
import { MatDialogModule } from "@angular/material/dialog";
import { LanguageService } from "libraries/service/language/language.service";
import { SafeHtmlPipeModule } from "libraries/pipes/safeHtml/safeHtml.module";
import { CardModule } from "libraries/ui_card/card.module";

@NgModule({
    imports: [
        CommonModule,
        BtnModule,
        MatDialogModule,
        SafeHtmlPipeModule,
        CardModule,
    ],
    exports: [ImportantInformationComponent],
    entryComponents: [ImportantInformationComponent],
    declarations: [ImportantInformationComponent],
    providers: [LanguageService],
})
export class ImportantInformationModule {
}
